module.exports = __webpack_public_path__ + "static/media/610.37bec341.webp";